import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from '../gsap-club/gsap-business-green/src/SplitText';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
gsap.registerPlugin( ScrollTrigger, SplitText, CustomEase );

/* eslint-disable */
(function () {
	let mm = gsap.matchMedia();

	mm.add({
		isMin0: '(min-width: 0px)',
		isMin1024: '(min-width: 1024px)',
		reduceMotion: '(prefers-reduced-motion: reduce)',
	},
		(context) => {
			// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
			let { isMin0, isMin1024, reduceMotion } = context.conditions;
			const featureScroll = document.querySelector('.feature-scroll');

			if (isMin0) {

				if (featureScroll) {
					const textItems = featureScroll.querySelectorAll('.feature-scroll__item');

					textItems.forEach((item) => {
						const itemText = item.querySelector('.feature-scroll__item-text');
						const splitText = new SplitText( itemText, {type: "chars, words", wordsClass: "word word++", linesClass: "line line++"} );

						let tl = gsap.timeline({
							scrollTrigger: {
								trigger: item,
								start: "top 80%",
								end: "top 60%",
								scrub: true,
							}
						});

						tl.to('.word', {
							y: 0,
							stagger: 0.005,
							duration: 0.005,
							autoAlpha: 1,
						})
					});
				}
			}
		});
})();
/* eslint-enable */

